import React from "react";
import PropTypes from "prop-types";

import { Icon, Segment } from "semantic-ui-react";

import Expandable from "components/Expandable";

export default function LinkedEntity({ entityType, title, children }) {
  if (!title) {
    return null;
  }

  const iconName = entityType === "task" ? "tasks" : "list ul";
  // Hacking in the marginTop since the quill settings all require custom CSS, so it appears to not
  // have a rounded radius for the bottom by overlapping with a negative margin and we'll most likely
  // be redoing most of this with the CSS upgrade
  return (
    <Segment
      style={{
        margin: "-1.0em 0 0.5em 0",
        border: "1px solid #ccc",
        borderRadius: "0 0 5 5",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "nowrap",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", flexWrap: "nowrap" }}>
          <div style={{ marginTop: "0.3em" }}>
            <Icon name={iconName} />
          </div>
          <div style={{ marginTop: "0.4em" }} data-test="linked-entity-title">
            <Expandable lines={1}>{title}</Expandable>
          </div>
          <div style={{ marginLeft: "0.5em" }}>{children}</div>
        </div>
      </div>
    </Segment>
  );
}

LinkedEntity.propTypes = {
  title: PropTypes.string.isRequired,
  entityType: PropTypes.string.isRequired,
  children: PropTypes.node,
};

LinkedEntity.defaultProps = {
  children: null,
};
